import { useQuery } from '@tanstack/react-query';
import { isToolOpenDenied } from '@/lib/tool-access/tool-access-bindings';
import { agentProfileQueryOptions } from '../../api/agents-fetch.api';
import type { Agent } from '../agent.types';

/**
 * A stand-in for an agent the caller may not open, built from its display profile, so a past chat
 * with it can still show whose it is. `undefined` for any other agent, and until the profile loads.
 */
export const useDeniedAgentProfile = (
  agentId: string | undefined,
  workspaceId: string | null | undefined,
): Agent | undefined => {
  const isDenied = !!agentId && isToolOpenDenied(agentId);
  const { data } = useQuery({
    ...agentProfileQueryOptions(agentId ?? '', workspaceId),
    enabled: isDenied && !!workspaceId,
  });
  return isDenied && data ? { ...data, isAccessDenied: true } : undefined;
};
